export default __webpack_public_path__ + "76e7b92efba50105d652f92e9e87c1ae.jpg";